const setMetrics = (metrics, store, relationships) => {
    metrics.setMetricDefinition('netWorthUsd', 'derivedBalances', 'sum', 'usdValue');
    metrics.setMetricDefinition('netWorthBtc', 'derivedBalances', 'sum', 'btcValue');
};

export default setMetrics;
